import React from 'react';
import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import {localePath, intlLocale} from '../../languages';
import {seoLinks} from '../../components/SeoLinks';
import Header from '../../components/Header';
import {SocialMeta} from '../../components/PageMeta/PageMeta';
import Footer from '../../components/Footer';
import config from '../../config';
import {getLegalContent, LEGAL_UPDATED_AT} from '../../legalContent';
import {openCookieSettings} from '../../cookieConsent';

const Legal = ({policy}) => {
    const {i18n} = useTranslation();
    const lang = i18n.language;
    const {pages, labels} = getLegalContent(lang);
    const page = pages[policy];
    const updated = new Intl.DateTimeFormat(intlLocale(lang), {dateStyle: 'long', timeZone: 'UTC'}).format(new Date(`${LEGAL_UPDATED_AT}T12:00:00Z`));
    const {name, address, country, registration} = config.legalSeller;
    const complete = Boolean(name && address && country);

    return (
        <>
            <title>{`${page.title} | YourLovely.Place`}</title>
            <SocialMeta title={`${page.title} | YourLovely.Place`} description={page.description}/>
            <meta name="description" content={page.description}/>
            <meta name="robots" content={complete ? 'index, follow' : 'noindex, follow'}/>
            {seoLinks(`/${policy}`, lang)}
            <Header/>
            <main className="legal-section" lang={lang}>
                <div className="design-container legal-container">
                    <header className="legal-heading">
                        <p className="legal-eyebrow">YourLovely.Place · {labels.legal}</p>
                        <h1>{page.title}</h1>
                        <p>{labels.lastUpdated}: <time dateTime={LEGAL_UPDATED_AT}>{updated}</time></p>
                    </header>
                    <article className="legal-card" aria-label={page.title}>
                        <p className="legal-intro">{page.intro}</p>
                        {policy === 'cookie-policy' && <button type="button" className="design-button" onClick={openCookieSettings}>{labels.changeCookieSettings}</button>}
                        {page.sections.map(({title, paragraphs, links}) => (
                            <section key={title}>
                                <h2>{title}</h2>
                                {paragraphs.map(text => <p key={text}>{text}</p>)}
                                {links && <ul className="legal-links">{links.map(({label, href}) => <li key={href}>{href.startsWith('/') ? <Link to={localePath(href, lang)}>{label}</Link> : <a href={href} target="_blank" rel="noreferrer">{label}</a>}</li>)}</ul>}
                            </section>
                        ))}
                        <section className="legal-contact">
                            <h2>{labels.contact}</h2>
                            <p>YourLovely.Place{name && <><br/>{name}</>}{address && <><br/>{address}</>}{country && <><br/>{country}</>}{registration && <><br/>{registration}</>}</p>
                            <a href={`mailto:${config.contactEmail}`}>{config.contactEmail}</a>
                        </section>
                    </article>
                    <nav className="legal-navigation" aria-label={labels.navigation}>
                        {Object.entries(pages).map(([slug, {title}]) => <Link key={slug} to={localePath(`/${slug}`, lang)} aria-current={policy === slug ? 'page' : undefined}>{title}</Link>)}
                    </nav>
                </div>
            </main>
            <Footer/>
        </>
    );
};

export default Legal;
